import React, { useContext } from 'react';
import { toCurrency } from '@app/utilities';
import { AccountContext } from '../AccountContext';
import { useGetAccount } from '@app/sdk';

export default function AvailableCredit() {
  const { accountId } = useContext(AccountContext);
  const { data: availableCredit, isLoading } = useGetAccount({ accountId });

  return (
    <>
      {!isLoading ? (
        <>
          <div className="ui grey label">Total Credit: {toCurrency(availableCredit?.availableCredit)}</div>
          <div className="ui grey label">
            Purchase Credit: {toCurrency(availableCredit?.availableCreditPerSpendType?.Purchase)}
          </div>
          <div className="ui grey label">
            Instalment Credit: {toCurrency(availableCredit?.availableCreditPerSpendType?.Instalment)}
          </div>
          {availableCredit?.availableCreditPerSpendType?.BNPL && 
            <div className="ui grey label">
              BNPL Credit: {toCurrency(availableCredit?.availableCreditPerSpendType?.BNPL)}
            </div>
          }
        </>
      ) : (
        <div className="ui active inline mini loader" />
      )}
    </>
  );
}
